module.exports = __webpack_public_path__ + "img/employers-bg.586d6bb9.webp";